<template>
    <div>
        <el-form
            style="background: #fff; padding: 20px"
            class="topForm"
            ref="form"
            :model="form"
            status-icon
            :rules="rules"
            label-width="100px"
        >
            <el-container style="background: #fff; border-radius: 15px; padding-top: 20px; padding-right: 20px; margin-bottom: 10px">
                <el-main style="padding: 0 20px 0 0;display:flex;justify-content:space-between">
                    <div style="display:flex;flex:8">
                        <el-form-item label="开始日期" prop="begin_date" style="flex:2">
                            <el-date-picker
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                                v-model="form.begin_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>

                        <el-form-item label="结束日期" prop="end_date" style="flex:2">
                            <el-date-picker
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                                v-model="form.end_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>

                        <el-form-item :label="$t('common.customer') " style="flex:2;">
                            <label slot="label">客&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户</label>
                            <mySelect
                                v-model="form.cust_no"
                                :options="allArr.cust"
                                values="cust_no"
                                labels="cust_name"
                                keys="cust_no"
                                style="width: 100%"
                            />
                        </el-form-item>
                    </div>

                    <!--<el-button type="primary" @click="Query('lx')">查询利息</el-button>
                    <el-button type="primary" @click="Query('cx')">查询仓息</el-button>
                    <el-button type="warning" @click="printContext">打印</el-button> -->
                    <div style="flex:2;text-align:right">
                        <el-button type="primary" @click="getCount('lx')">计算利息</el-button>
                        <el-button type="primary" @click="getCount('cx')">计算仓息</el-button>
                        <!-- <el-button type="danger" @click="Delete('lx')">删除利息</el-button>
                        <el-button type="danger" @click="Delete('cx')">删除仓息</el-button> -->
                    </div>
                </el-main>
            </el-container>

            <el-table
                style="font-size:14px"
                :data="tableData"
                border
                height="600"
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <template slot="empty">
                    <div style="margin: 0 auto;  position: relative;">
                        <img
                            src="@/assets/img/dontHave.png"
                            alt=""
                            style="width:250px;
                                height:250px;
                                position: fixed;    
                                 transform: translate(-50%,-50%);
                              "
                        />
                    </div>
                </template>
                <el-table-column type="index" width="50" align="center" label="序号"> </el-table-column>
                <el-table-column prop="interesttype" label="类型" width="150"></el-table-column>
                <el-table-column prop="begin_date" label="计息开始日期" width="160"></el-table-column>
                <el-table-column prop="end_date" label="计息结束日期" width="160"></el-table-column>
                <el-table-column prop="cust_name" label="客户名称" width="150"></el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" type="success" plain>已完成</el-tag>
                        <el-tag v-if="scope.row.status == 0" type="warning" plain>计算中</el-tag>
                        <el-tag v-if="scope.row.status == -1" type="info">已删除</el-tag>
                        <el-tag v-if="scope.row.status == -2" type="danger">错误</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="build_name" :label="$t('common.creator')" width="150"></el-table-column>
                <el-table-column prop="build_date" :label="$t('common.createTime')" width="160" sortable></el-table-column>
                <el-table-column prop="delete_name" label="删除人" width="150"></el-table-column>
                <el-table-column prop="delete_date" label="删除时间" width="160" sortable></el-table-column>
                <el-table-column label="操作" width="150" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" class="to-blue-500" @click="handleDetails(scope.row)" v-if="perData.allow_use == 1"
                            >查看</el-button
                        >
                        <el-button type="text" style="color:#F56C6C" @click="Delete(scope.row)" v-if="perData.allow_dele == 1"
                            >{{ $t('common.delete') }}</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="form.page"
                    :page-size="form.page_size"
                    :page-sizes="[10, 50, 100]"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </el-form>
    </div>
</template>

<script>
import {
    apiCustInterest_count,
    // apiCustInterest_query,
    // apiCustInterest_notice,
    apiCustInterest_list,
    apiCustInterest_pull,
    apiCurrentPermisson,
    apiCustInterest_delete,
    apiSystem
} from '@/request/api';
import axios from 'axios';
import mySelect from '@/components/component/select.vue';
export default {
    name: 'custInterest',
    data() {
        return {
            form: {
                begin_date: '',
                end_date: '',
                page: 1,
                page_size: 10
            },
            rules: {
                begin_date: [{ required: true, message: '请选择起始日期', trigger: 'change' }],
                end_date: [{ required: true, message: '请选择结束日期', trigger: 'change' }]
            },
            allArr: '',

            pageTotal: 0,
            perData: '',
            systemSet: '',

            tableData: [],
            headOne: [],
            headTwo: [],

            title: ''
        };
    },
    components: { mySelect },
    mounted() {
        this.getData();
        this.getPull();
        this.getPermission();
        // this.Query();
        // 检测是否为带有参数跳转
        // this.queryAuto();
    },
    methods: {
        handleDetails(row) {
            if (row.interesttype == '利息') {
                this.$router.push({
                    path: 'custInterestRep',
                    query: { begin_date: row.begin_date, end_date: row.end_date, cust_no: row.cust_no }
                });
            } else if (row.interesttype == '仓息') {
                this.$router.push({
                    path: 'custStockinterestRep',
                    query: { begin_date: row.begin_date, end_date: row.end_date, cust_no: row.cust_no }
                });
            }
        },
        getPull() {
            apiCustInterest_pull({}).then(res => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                } else {
                    this.message('err', res);
                }
            });
        },
        getData() {
            apiCustInterest_list(this.form).then(res => {
                console.log(res);
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.page_total;
                    // this.Query(type);
                } else {
                    this.message('err', res);
                }
            });
        },
        getCount(type) {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (type == 'lx') this.form.type = '利息';
                    else this.form.type = '仓息';
                    this.$load.show();
                    this.form.login_staff = localStorage.getItem('ms_username');
                    apiCustInterest_count(this.form)
                        .then(res => {
                            if (res.code == 2000) {
                                this.getData();
                                this.message('suc', res);
                                // this.Query(type);
                            } else {
                                this.message('err', res);
                            }
                        })
                        .catch(rej => {
                            // apiCustInterest_notice(this.form).then(res => {
                            //     if (res.code == 2000) {
                            //         this.$message({
                            //             type: 'success',
                            //             showClose: true,
                            //             duration: 10000000,
                            //             message: '请求时间过长,已移至云端运算,运算结果会与公告的形式发送给您,请注意查收'
                            //         });
                            //     } else {
                            //         this.message('err', res);
                            //     }
                            // });
                            this.getData();
                        })
                        .finally(() => {
                            this.$load.close();
                        });
                } else {
                    // this.$message.error('请选择必填信息');
                    return false;
                }
                this.getData();
            });
        },
        // 查询
        // Query(type = 'lx') {
        //     this.arrReset();
        //     if (type == 'lx') {
        //         this.form.type = '利息';
        //         this.title = '客户利息表';
        //     } else {
        //         this.form.type = '仓息';
        //         this.title = '客户仓息表';
        //     }
        //     this.$load.show();
        //     return apiCustInterest_query(this.form)
        //         .then(res => {
        //             if (res.code == 2000) {
        //                 this.pageTotal = res.data.count;
        //                 this.headOne = res.data.head[0];
        //                 this.headTwo = res.data.two[0];
        //                 this.tableData = res.data.data;
        //             } else {
        //                 this.message('err', res);
        //             }
        //             return res;
        //         })
        //         .finally(() => {
        //             this.$load.close();
        //         });
        // },
        // 清空
        // arrReset() {
        //     // this.pageTotal = 0;
        //     this.headOne = [];
        //     this.headTwo = [];
        //     this.tableData = [];
        // },
        // 删除利息/仓息
        Delete(row) {
            this.$load.show();
            apiCustInterest_delete({
                login_staff: localStorage.getItem('ms_username'),
                id: row.id
            })
                .then(res => {
                    if (res.code == 2000) {
                        this.message('suc', res);
                        this.getData();
                    } else {
                        this.message('err', res);
                    }
                })
                .finally(() => {
                    this.$load.close();
                });
        },
        printContext() {
            if (this.tableData.length <= 0) {
                this.$message.error('暂无数据');
                return;
            }
            this.$print(this.$refs.print);
        },
        // 错误提示 封装
        message(type, res) {
            if (type == 'suc') {
                this.$message({
                    type: 'success',
                    message: res.msg,
                    duration: 2000,
                    showClose: true
                });
            } else if (type == 'err') {
                this.$message.error({
                    message: res.data.info,
                    duration: 2000,
                    showClose: true
                });
            }
        },
        // 跳转参数自动查询
        queryAuto() {
            const { query, params } = this.$route;
            let obj = null;
            if (query.type || params.type) {
                if (query.type) obj = query;
                else obj = params;
                this.$set(this.form, 'begin_date', obj.begin_date);
                this.$set(this.form, 'end_date', obj.end_date);
                this.$set(this.form, 'type', obj.type);
                if (obj.cust_no) this.$set(this.form, 'cust_no', obj.cust_no);
                this.Query();
            }
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.$set(this.form, 'page', val);
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.$set(this.form, 'page_size', val);
            this.getData();
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '90'
            }).then(res => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.message('err', res);
                }
            });
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then(res => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.message('err', res);
                }
            });
        }
    }
};
</script>

<style scoped>
.company {
    text-align: center;
    font-size: 16px;
    color: rgb(7, 16, 114);
    font-weight: bold;
    letter-spacing: 5px;
}
.custtable .el-select {
    width: 80%;
    margin-top: 10px;
}
@media print {
    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
    }
}
</style>
